import useOmeMeetEntryInfoDropdown from './UseOmeMeetEntryInfoDropdown';

import Dropdown from '@usas/ui-web/components/dropdowns/Dropdown';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const OmeMeetEntryInfoDropdown = ({ label, name, value, error, message, onChange, omeMeetId, isCurrent }) => {
  const { omeMeetEntryInfoState } = useOmeMeetEntryInfoDropdown(omeMeetId, isCurrent);

  return omeMeetEntryInfoState.message
    ? <span className={global.LoadingMsg}>{omeMeetEntryInfoState.message}</span>
    : (
      <Dropdown
        error={error}
        label={label}
        message={message}
        options={omeMeetEntryInfoState.options}
        name={name}
        value={value}
        onChange={onChange}
        isLoading={omeMeetEntryInfoState.isArrayLoading}
        areValuesIntegers={true}
      />
    );
};

export default OmeMeetEntryInfoDropdown;